﻿module.exports = function($) {
    return {
        init: function() {
            var removeFromGlossaryPage = $(".removeFromGlossary").length > 0;
            if (removeFromGlossaryPage)
                this.bindEvents();
        },
        bindEvents: function () {
            $('.removeFromGlossary__remove').on('click', function (e) {

                e.stopPropagation();
                var source = $(this);
                var item = source.parents('.glossaryUpgrade__results__list__item');
                var termId = item.attr("data-term-id");
                var glossaryId = $(this).attr("data-glossary-id");
                var message = $(this).parent().children('.removeFromGlossary__message').hide();
                var successMsg = $(".success", message);
                var errorMsg = $(".error", message);
                successMsg.hide();
                errorMsg.hide();

                // Fire off ajax and remove.
                $.ajax({
                    url: '/umbraco/surface/Member/RemoveTerm/',
                    type: 'POST',
                    traditional: true,
                    dataType: 'json',
                    data: {
                        glossaryId: glossaryId,
                        termId: termId
                    },
                    success: function (data) {

                        successMsg.show();

                        setTimeout(function () {
                            // Remove item
                            source.parents('.glossaryUpgrade__results__list__item').remove();
                        }, 1500);
                    },
                    error: function (result) {
                        errorMsg.show();
                    },
                    complete: function () {
                        message.fadeIn();
                        setTimeout(function () {
                            message.fadeOut();
                        }, 2500);
                    }
                });

            });
        }
    }
}